import { Box, Button } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { AddIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';

interface BlockSeparatorProps {
  onClick: () => void;
}

export const BlockSeparator = ({ onClick }: BlockSeparatorProps): ReactElement => {
  return (
    <Box
      position="absolute"
      bottom={0}
      left={0}
      right={0}
      transform="translateY(100%)"
      height="20px"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      contentEditable={false}
      zIndex={1}
      _hover={{
        '&::before': {
          content: '""',
          position: 'absolute',
          left: 0,
          right: 0,
          height: '2px',
          backgroundColor: 'background.accent',
          opacity: '50',
        },
        '& .add-button': {
          opacity: 1,
          transform: 'scale(1)',
        },
      }}
    >
      <Button
        className="add-button"
        size="m"
        variant="primary"
        onClick={onClick}
        cursor="pointer"
        opacity="none"
        transform="scale(0.8)"
        transition="all 0.2s ease-in-out"
      >
        <NovaIcon icon={AddIcon} size="s" aria-hidden />
        Block einfügen
      </Button>
    </Box>
  );
};
